<div style="text-align: center;" matTooltip="Marketplace" matTooltipClass="tooltip-large" [matTooltipPosition]="'before'">
    <img src="assets/spaces/TheGrandTezaar_tr.png" height="100" (click)="showDialog()">
</div>
